import { EXCHANGE_RATES } from '../../../../ALL_PRICES/PRICES';
import { loadLs, saveLs } from '../../../storage/localStorage';
import { renderPrice } from './selectedCars';

export const CURRENCY = {
  CZK: {
    title: 'CZK',
    symbol: 'Kč',
    exchangeRate: EXCHANGE_RATES.CZK,
  },
  USD: {
    title: 'USD',
    symbol: '$',
    exchangeRate: EXCHANGE_RATES.USD,
  },
  EUR: {
    title: 'EUR',
    symbol: '€',
    exchangeRate: EXCHANGE_RATES.EUR,
  },
};

export let currentCurrency = CURRENCY.EUR;

// =====================================
// Селектори
// =====================================
const refs = {
  allButtons: document.querySelectorAll('.currency-toggle__btn'),
  currentLang: document.documentElement.lang || 'en',
};
const { allButtons, currentLang } = refs;

const KEY_LS = 'current-currency';

// =====================================
// Функція для оновлення currentCurrency і збереження в localStorage
// =====================================
export const updateCurrentCurrency = newCurrency => {
  if (CURRENCY[newCurrency]) {
    currentCurrency = CURRENCY[newCurrency];
    saveLs(KEY_LS, currentCurrency);

    allButtons?.forEach(button => {
      if (button.dataset.currency === newCurrency) {
        button.classList.add('active');
        button.setAttribute('aria-pressed', 'true');
      } else {
        button.classList.remove('active');
        button.setAttribute('aria-pressed', 'false');
      }
    });
  }
};

// =====================================
// Ініціалізація currentCurrency з localStorage
// =====================================
const savedCurrency = loadLs(KEY_LS);
if (savedCurrency) {
  updateCurrentCurrency(savedCurrency.title);
} else {
  // Встановлюємо валюту за замовчуванням залежно від мови
  if (currentLang === 'cs') {
    updateCurrentCurrency(CURRENCY.CZK.title);
  } else {
    updateCurrentCurrency(CURRENCY.EUR.title);
  }
}

// =====================================
// Слухачі для кнопок зміни валюти
// =====================================
allButtons?.forEach(button => {
  // initialize aria-pressed for accessibility
  button.setAttribute(
    'aria-pressed',
    button.classList.contains('active') ? 'true' : 'false'
  );
  button.addEventListener('click', event => {
    const newCurrency = event.currentTarget.dataset.currency;
    updateCurrentCurrency(newCurrency);

    renderPrice();
  });
});
